import { Mapper } from '@/core/mapper/base-mapper';
import type { GetCustomReportByTypeListResponseDTO } from '@/core/dto/custom-reports/get-custom-report-by-type-list';
import { REPORT_ACRONYM_KEYS, REPORT_TYPES, REPORT_ACRONYMS } from '@/utils/constants';

export class GetCustomReportByTypeListMapper implements Mapper<GetCustomReportByTypeListResponseDTO> {
	constructor(private readonly data: GetCustomReportByTypeListResponseDTO) {}

	private getReportType(acronym: string): string {
		const acronymToTypeMap = {
			[REPORT_ACRONYMS.BERA]: REPORT_TYPES.BERA,
			[REPORT_ACRONYMS.SERA]: REPORT_TYPES.SERA
		} as const;

		return acronymToTypeMap[acronym as keyof typeof acronymToTypeMap] || REPORT_TYPES.CUSTOM;
	}

	toDomain(): GetCustomReportByTypeListResponseDTO {
		return {
			...this.data,
			rows: this.data.rows.map((item) => ({
				...item,
				report_type: this.getReportType(item.acronym),
				acronym: REPORT_ACRONYM_KEYS[item.acronym as keyof typeof REPORT_ACRONYM_KEYS] ?? item.acronym
			}))
		};
	}
}
